import { usePartnerDris } from "src/api/hooks";
import { ReadFailure } from "src/components/read-failure";
import { Field, Select } from "src/components/ui";

export function PartnerDRIField({
  value,
  onChange,
  legacy = false
}: {
  value: string;
  onChange: (value: string) => void;
  legacy?: boolean;
}) {
  const { data, isPending, error } = usePartnerDris();
  return (
    <Field label="DRI" required={!legacy}>
      <Select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={isPending || Boolean(error)}
      >
        <option value="" disabled={Boolean(value)}>
          {legacy ? "Not recorded" : "Choose…"}
        </option>
        {(data?.partnerDris ?? []).map((dri) => (
          <option key={dri.id} value={dri.id}>
            {dri.name}
          </option>
        ))}
      </Select>
      {error ? <ReadFailure error={error} /> : null}
    </Field>
  );
}
